import React from 'react';

export const IconSmallPublicLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M10.748 17.87L10 16a1.5 1.5 0 01-1.5-1.5v-1l-2.429-2.429a6.002 6.002 0 004.676 6.798zm3.225-11.538A2 2 0 0112 8h-1v1a1 1 0 01-1 1H9v2h3a1 1 0 011 1v1a1 1 0 011 1v2.659a6.017 6.017 0 003-2.341V12h-1a1 1 0 01-1-1V9l.815-1.63a5.99 5.99 0 00-1.842-1.038zM20 12a8 8 0 11-16 0 8 8 0 0116 0z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
